// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3504":"1dd22ff0","4124":"1dd22ff0","4375":"1dd22ff0","4577":"1dd22ff0","4836":"3d155ff7","6346":"cac3387d","9998":"3b53517f"}[chunkId] + ".chunk.css";
};